import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'firebaseMeasurementId',
  initialState: null as null | string,
  reducers: {
    setFirebaseMeasurementId(state, action: PayloadAction<string | null>) {
      return action.payload || null;
    },
  },
});

export const { setFirebaseMeasurementId } = slice.actions;

export default slice.reducer;
